export const LINEA_NEGOCIO = {
  CON_RESPONSABILIDAD: 'ConResponsabilidad',
  SIN_RESPONSABILIDAD: 'SinResponsabilidad',
  CON_FINANCIACION: 'ConFinanciacion',
  CONDICIONADO: 'Condicionado',
  CON_DESCUENTO: 'ConDescuento',
  DE_NEGOCIACION: 'DeNegociacion'
} as const;

export type LineaNegocio = typeof LINEA_NEGOCIO[keyof typeof LINEA_NEGOCIO];
